import { RulesConstants, RulesTracks } from './RulesConstants';
import './Rules.scss';
import { v4 as uuid } from 'uuid';
import { debounce } from 'data/function';
import { ToastType } from 'modules/application/misc/ToastService';
export class RulesController {
    static $inject = ['application', '$scope', 'DeskConfigurationService', 'LoadingService', 'AlertService', 'SegmentService', 'RulesService', '$translate', 'LoadValues', 'PermissionsService', '$state'];
    constructor(application, $scope, DeskConfigurationService, LoadingService, AlertService, SegmentService, RulesService, $translate, LoadValues, PermissionsService, $state) {
        'ngInject';
        this.application = application;
        this.$scope = $scope;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.AlertService = AlertService;
        this.SegmentService = SegmentService;
        this.RulesService = RulesService;
        this.$translate = $translate;
        this.LoadValues = LoadValues;
        this.PermissionsService = PermissionsService;
        this.$state = $state;
        this.currentState = RulesConstants.STATES.VIEWING;
        this.rulesTotalCount = 0;
        this.inputTextSearchRules = '';
        this.isManagerView = true;
        this.isAgentPaginatorEnabled = true;
        this.searchRule = async (event) => {
            this.inputTextSearchRules = event.detail.value;
            await this.getRules(true);
            this.SegmentService.createBotTrack(RulesTracks.RULES_SEARCHED, this.application, this.trackPayload);
        };
    }
    async $onInit() {
        this.properties = await this.LoadValues.loadProperties();
        this.relations = await this.LoadValues.loadRelations();
        this.operators = await this.LoadValues.loadOperators();
        this.teams = await this.RulesService.fetchTeams(this.application);
        this.itemsPerPage = 100;
        this.canEditRule = await this.PermissionsService.hasPermissions('write', 'desk');
        this.canSeeRule = await this.PermissionsService.hasPermissions('read', 'desk');
        this.isEditing = false;
        this.trackPayload = {
            source: RulesTracks.SOURCE.PORTAL,
        };
        this.debouncedSearch = debounce(this.searchRule, 500);
        await this.getRules(true);
        this.SegmentService.createBotTrack(RulesTracks.PAGE_OPENED, this.application);
        this.setIsLoading(false);
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    cancelAction(index) {
        if (this.currentState === RulesConstants.STATES.ADDING) {
            this.rules.splice(index, 1);
        }
        else if (this.currentState === RulesConstants.STATES.EDITING) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(RulesConstants.STATES.VIEWING);
    }
    async toggleRule(rule) {
        await this.RulesService.set(this.application, rule);
    }
    async closeOpenedRule(index) {
        if (this.rules[index] && this.rules[index].opened) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(RulesConstants.STATES.VIEWING);
        this.teams = await this.RulesService.fetchTeams(this.application);
    }
    async editRule(index) {
        this.setCurrentState(RulesConstants.STATES.EDITING);
        await this.changeStatusItem(index);
    }
    async changeStatusItem(index) {
        for (const [i, rule] of this.rules.entries()) {
            rule.opened = i === index ? !rule.opened : false;
        }
    }
    async loadMore() {
        if (!this.canLoadMore || this.isLoading) {
            return;
        }
        await this.getRules();
    }
    async clearSearch() {
        this.inputTextSearchRules = '';
        this.currentState = RulesConstants.STATES.VIEWING;
        await this.getRules(true);
        this.SegmentService.createBotTrack(RulesTracks.CLEAR_SEARCH, this.application, this.trackPayload);
    }
    async changeStatus(value, index) {
        if (this.canEditRule) {
            const rule = {
                ...this.rules[index],
                isActive: value,
            };
            this.saveRule(rule, index);
        }
        else {
            this.RulesService.showToast('builder-attendance-rules.errors.cannotEdit', ToastType.Danger);
        }
    }
    async getRules(reset = false) {
        if (this.isLoading) {
            return;
        }
        if (reset) {
            this.rules = [];
        }
        this.setIsLoading(true);
        this.canLoadMore = false;
        try {
            const { rules, total } = await this.RulesService.getFilterRules(this.inputTextSearchRules, this.rules.length, this.itemsPerPage);
            this.rulesTotalCount = total;
            this.rules.push(...rules);
            if (this.rules.length !== this.rulesTotalCount) {
                this.canLoadMore = true;
            }
        }
        catch (e) {
            this.rules = [];
        }
        finally {
            this.setIsLoading(false);
        }
    }
    async createRule() {
        if (this.currentState === 'ADDING' || this.currentState === 'EDITING') {
            return;
        }
        this.setCurrentState(RulesConstants.STATES.ADDING);
        const title = await this.$translate('builder-attendance-rules.rules.ruleName');
        const newRule = {
            id: uuid(),
            title: `${title} ${this.rulesTotalCount + 1}`,
            conditions: [
                {
                    property: 'Message',
                    relation: 'Contains',
                    values: [],
                },
            ],
            team: RulesConstants.DEFAULT_TEAM_NAME,
            queueId: undefined,
            isActive: true,
            opened: true,
            operator: RulesConstants.DEFAULT_OPERATOR,
            repeatConditionsBody: false,
            valuesEmpty: true,
        };
        this.rules = this.rules.concat(newRule);
        const input = document.getElementById(`rule-title-${this.rules.length - 1}`);
        if (input) {
            input.focus();
            this.changeStatusItem(this.rules.length - 1);
        }
        this.SegmentService.createBotTrack(RulesTracks.RULE_ADDED, this.application, this.trackPayload);
    }
    clearRuleList(data) {
        if (data.id) {
            return;
        }
        this.rules.pop();
    }
    async saveRule(data, index) {
        let rule;
        let toastMessageReference;
        let toastType;
        this.LoadingService.startLoading();
        rule = {
            id: uuid(),
            team: RulesConstants.DEFAULT_TEAM_NAME,
            ...data,
        };
        toastMessageReference =
            this.currentState === RulesConstants.STATES.ADDING
                ? 'attendance-rules.rules.confirmAddRule'
                : 'attendance-rules.rules.confirmEdit';
        try {
            await this.RulesService.set(this.application, rule);
            if (this.currentState === RulesConstants.STATES.ADDING) {
                await this.getRules(true);
            }
            this.SegmentService.createBotTrack(RulesTracks.RULE_SAVED, this.application, this.trackPayload);
            toastType = ToastType.Success;
        }
        catch (ex) {
            toastMessageReference = 'utils.errorMsg.112';
            toastType = ToastType.Danger;
        }
        finally {
            this.closeOpenedRule(index);
            this.LoadingService.stopLoading();
            await this.RulesService.showToast(toastMessageReference, toastType);
            this.setIsLoading(false);
        }
    }
    async confirmDelete(rule) {
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteBody', { team: rule.team });
            const confirm = await this.$translate('utils.forms.exclude');
            const cancel = await this.$translate('utils.forms.cancel');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.delete(rule),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(rule) {
        let toastMessageReference;
        let toastType;
        try {
            this.LoadingService.startLoading();
            this.RulesService.delete(rule);
            this.rules = this.rules.filter(obj => obj.id !== rule.id);
            this.rulesTotalCount--;
            toastMessageReference = 'attendance-rules.rules.confirmRemoveRule';
            toastType = ToastType.Success;
            this.SegmentService.createBotTrack(RulesTracks.RULE_DELETED, this.application, this.trackPayload);
        }
        catch (e) {
            toastMessageReference = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.LoadingService.stopLoading();
            await this.RulesService.showToast(toastMessageReference, toastType);
        }
    }
    isAnyRuleOpen() {
        return this.rules.some(r => r.opened);
    }
}
RulesController.$inject = ['application', '$scope', 'DeskConfigurationService', 'LoadingService', 'AlertService', 'SegmentService', 'RulesService', '$translate', 'LoadValues', 'PermissionsService', '$state'];
